import { useCallback } from 'react';
import { useController } from 'react-hook-form';
import { IncField } from '../fields.types';
import IncSwitchBase, {
  IncSwitchBaseProps,
} from './inc-switch-base/inc-switch-base.component';

type IncSwitchFieldProps = IncField<Partial<IncSwitchBaseProps>>;

export const IncSwitchField = ({
  name,
  label,
  onChange,
  ...rest
}: IncSwitchFieldProps) => {
  const { field, fieldState } = useController({ name });
  const { error } = fieldState;
  const { onChange: fieldOnChange, ...fieldRest } = field;

  const finalOnChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      fieldOnChange(event);
      if (!!onChange) onChange(event, checked);
    },
    [fieldOnChange, onChange],
  );

  return (
    <IncSwitchBase
      label={label}
      error={error}
      onChange={finalOnChange}
      {...rest}
      {...fieldRest}
    />
  );
};

export default IncSwitchField;
